/* eslint react/jsx-props-no-spreading: 0 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';
import { FormFeedback, Input, Label } from 'reactstrap';
import { useIntl } from 'react-intl';
import capitalizeFirstLetter from '../../../utils/capitalizeFirstLetter';

interface FormikTextareaProps {
  name: string;
  id?: string;
  required?: boolean;
  formik: any;
  children: any;
  className?: string;
}

function FormikTextarea(props: FormikTextareaProps): JSX.Element {
  const { formatMessage } = useIntl();
  const { name, id, required, children, formik, className } = props;
  const { touched, error } = formik.getFieldMeta(name);

  return (
    <div className={className || ''}>
      <Label for={name} className={required ? 'required' : ''}>
        {capitalizeFirstLetter(children)}
      </Label>
      <Input
        invalid={touched && error}
        type="textarea"
        style={{ minHeight: 140 }}
        name={name}
        id={id || name}
        {...formik.getFieldProps(`${name}`)}
      />
      {error && <FormFeedback>{formatMessage({ id: error })}</FormFeedback>}
    </div>
  );
}

export default FormikTextarea;
